import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Button } from 'antd';

export function BtnInfoNext(props){
  let { id } = props.course.url;
  const next = parseInt(id, 10) + 1;

  const changeLesson = () => props.onClick(next);

  if(next <= props.course.length){
    return (
      <Button
        id="btn-info-next"
        icon="caret-right"
        onClick={changeLesson}
        style={props.style}
        >
        Next
      </Button>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnInfoNext.js